import { Avatar, Box, Typography, IconButton, Menu, MenuItem, ListItemIcon, AppBar, useTheme, Tooltip } from "@mui/material"
import MenuIcon from '@mui/icons-material/Menu'
import { useEffect, useState } from "react"
import { useUserStore } from "../../store/user.store"
import LogoutIcon from '@mui/icons-material/Logout'
import { useAuthStore } from "../../store/auth.store"
import aliveTextLogo from '../../assets/alivelogo.png'
import { useLayoutContext } from "../../contexts/layout.context"
import { erpDashboardLink, Icons } from "../../utils/utilities"
import { Link, useNavigate } from 'react-router-dom'
import api from "../../service/api"

const Navbar = ( { paddingRight } ) => {

    // const [user, setUser] = useState( null )
    const [anchorEl, setAnchorEl] = useState( null )
    const [profile, setProfile] = useState( null )
    const UserStore = useUserStore()
    const AuthStore = useAuthStore()
    const open = Boolean( anchorEl )
    const navigate = useNavigate()

    const { isSmallScreen, setSidedrawerState, sidedrawerState, setCurrentLoc } = useLayoutContext()
    const { palette, zIndex } = useTheme()

    const logout = async () => {
        await AuthStore.doLogout()
        window.location.replace( erpDashboardLink )
    }

    const navigateHome = () => {
        navigate( '/faculty/home' )
        setCurrentLoc( '/faculty/home' )
    }

    useEffect( () => {
        const getProfileImage = async () => {
            try {
                const { data: image } = await api.fetchProfileImage( UserStore.getUser?.image_path )
                const fileReader = new FileReader()
                fileReader.onload = () => {
                    setProfile( fileReader.result )
                }
                fileReader.readAsDataURL( image )
            } catch ( err ) {

            }
        }
        getProfileImage()
    }, [UserStore] )

    return (
        <AppBar id="appbar" elevation={0} sx={{ borderRadius: "0", zIndex: zIndex.drawer + 1, background: palette.background.paper, position: "absolute", color: "black", width: "100%", height: "fit-content" }}>
            <Box alignItems="center" justifyContent="space-between" padding="10px" paddingRight={paddingRight ? `${paddingRight}px` : "10px"} display="flex" maxWidth="100%" id="app-bar" sx={{ transition: "0.2s ease-out", '@media(max-width:1100px)': { padding: "10px" }, paddingLeft: "20px" }}>
                <Box display="flex" alignItems="center">
                    <IconButton onClick={() => setSidedrawerState( !sidedrawerState )} sx={{ marginRight: "10px", marginBottom: "-5px", color: "#262729", display: !isSmallScreen ? "none" : "block" }}>
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{ cursor: "pointer" }} onClick={navigateHome} display="flex" alignItems="center" gap="20px">
                        <img src={aliveTextLogo} width="40px" alt="alive-logo" />
                        <Box>
                            <Typography variant='h6' margin="0" fontSize={{ sm: "16px", xs: "16px" }}>Alive</Typography>
                            <Typography variant='subtitle2' marginTop="-2px" fontWeight="400" fontSize="12px">Digital Classrooms</Typography>
                        </Box>
                    </Box>
                </Box>
                {<Box display="flex" paddingRight="20px" alignItems="center" gap="10px">
                    <Box display={{ sm: "flex", xs: "none" }} gap="10px" alignItems="center" >
                        <Link to="/faculty/faq" className='default-link'><Typography display="flex" gap="5px" alignItems="center" color="GrayText" fontWeight="500" textAlign="right" fontSize="14px">
                            {Icons.default.LiveHelpIcon}
                            Tutorials
                        </Typography></Link>
                        <Typography marginLeft="30px" color="GrayText" fontWeight="500" textAlign="right" fontSize="14px" textTransform="upppercase">{UserStore.getUser["user_name"] ? UserStore.getUser["user_name"].split( " " )[0] : ""}</Typography>
                        <Tooltip placement="bottom" title={UserStore.getUser["user_name"] ? UserStore.getUser["user_name"] : ""}>
                            <IconButton onClick={( e ) => setAnchorEl( e.currentTarget )}>
                                <Avatar slotProps={{ img: { sx: { objectFit: "contain" } } }} src={profile ? profile : undefined} sx={{ height: "32px", width: "32px" }}>
                                </Avatar>
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Menu slotProps={{ paper: { sx: { minWidth: "170px" } } }} onClose={e => { setAnchorEl( null ) }} transformOrigin={{ horizontal: 'right', vertical: 'top' }} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }} anchorEl={anchorEl} open={open}>
                        <Box display="block">
                            <Typography textAlign="center" padding="0 20px" variant='subtitle1' textTransform="capitalize">{UserStore.getUser["user_name"] ? UserStore.getUser["user_name"] : ""}</Typography>
                            <Typography textAlign="center" padding="0 20px" fontSize="10px">{UserStore.getUser["user_role"] ? UserStore.getUser["user_role"] : ""}</Typography>
                        </Box>
                        <MenuItem dense sx={{ color: "error.dark", alignItems: "center", justifyContent: "center", marginTop: "10px", display: "flex" }} onClick={logout}>
                            <ListItemIcon >
                                <LogoutIcon color="error" fontSize="small" />
                            </ListItemIcon>
                            Back to ERP
                        </MenuItem>
                    </Menu>
                </Box>}
            </Box>
        </AppBar>
    )
}

export default Navbar
